export default __webpack_public_path__ + "static/media/docker.d6d90628.svg";